import { products } from "@/data/productData";

const ProductFeature = ({ feature }) => (
  <div className="flex items-center gap-2">
    <div className="w-1.5 h-1.5 rounded-full bg-forest" />
    <span className="text-xs text-gray-600">{feature}</span>
  </div>
);

const ProductCard = ({ product }) => (
  <div 
    className="product-card bg-white rounded-3xl p-6 group"
    data-testid={`product-card-${product.id}`}
  >
    <div className="product-image-container bg-sage/20 flex items-center justify-center mb-6">
      <img 
        src={product.image}
        alt={product.name}
        className="w-full h-full object-cover"
      />
    </div>

    <div className="space-y-3">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <span className="text-xs font-medium text-forest bg-sage px-3 py-1 rounded-full">
          {product.size}
        </span>
        {product.alsoAvailable && (
          <span className="text-xs text-gray-500 italic">
            {product.alsoAvailable}
          </span>
        )}
        {product.featured && (
          <span className="text-xs font-medium text-citrus-dark bg-citrus/20 px-3 py-1 rounded-full">
            Featured
          </span>
        )}
      </div>
      <h3 className="font-serif text-xl font-semibold text-forest">
        {product.name}
      </h3>
      <p className="text-sm text-gray-500">
        {product.tagline}
      </p>
      <p className="text-sm text-gray-600 leading-relaxed">
        {product.description}
      </p>

      <div className="pt-3 space-y-2">
        <ProductFeature feature={product.features[0]} />
        <ProductFeature feature={product.features[1]} />
        <ProductFeature feature={product.features[2]} />
      </div>
    </div>
  </div>
);

export const ProductsSection = () => {
  return (
    <section 
      id="products" 
      className="py-20 md:py-32 px-6 md:px-12 relative overflow-hidden"
      data-testid="products-section"
    >
      {/* Elegant natural background */}
      <div className="absolute inset-0 bg-gradient-to-br from-sage/40 via-sage/20 to-white" />
      <div className="absolute inset-0 botanical-pattern opacity-50" />
      
      {/* Decorative blobs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-forest/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-citrus/10 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-sage/20 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <span className="inline-block text-sm font-medium text-forest bg-white px-4 py-2 rounded-full">
            Our Products
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-forest">
            Clean Home, Clean Planet
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base md:text-lg">
            Discover our complete range of plant-based cleaning solutions
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          <ProductCard product={products[0]} />
          <ProductCard product={products[1]} />
          <ProductCard product={products[2]} />
          <ProductCard product={products[3]} />
        </div>
      </div>
    </section>
  );
};
